var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status",class:_vm.status,attrs:{"title":_vm.schedule}},[(_vm.isScheduled)?_c('mdi',{staticStyle:{"font-size":"larger"},attrs:{"clock-outline":""}}):_vm._e(),_vm._v(" "+_vm._s(_vm.status)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }